import { Route, Routes } from "react-router-dom";
import PrivateRoutes from "../../core/routes/PrivateRoutes";
import { ListarEstabelecimentos } from "../pages/ListarEstabelecimentos";
import { CriarEstabelecimento } from "../pages/CriarEstabelecimento";
import { Layout } from "../../core/components/Layout";

interface IEstabelecimentosRoutesProps {
    autenticado: boolean;
}

export const EstabelecimentosRoutes = ({ autenticado }: IEstabelecimentosRoutesProps) => {
    return (
        <Routes>
            <Route element={
                <Layout titulo="Estabelecimentos">
                    <PrivateRoutes
                        autenticado={autenticado}
                    />
                </Layout>
            }>
                <Route path="/" index element={<ListarEstabelecimentos />} />
                <Route path="/criar" element={<CriarEstabelecimento />} />
            </Route>
        </Routes>
    );
}
